/* AquaStash V3 "Deep Dive": behaviour for the as-* sections.
   Plain JS, no dependencies. Works alongside the Taiga base (global.js, cart.js). */
(function () {
  'use strict';
  var AS = (window.AS = window.AS || {});
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (sel, el) { return (el || document).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); };
  var clamp = function (x, a, b) { return Math.max(a, Math.min(b, x)); };

  /* money:start (tests/money.test.mjs runs this block on its own) */
  /* ---------- money ----------
     Every price this theme hands to JavaScript comes from Liquid, so it is already in the shopper's currency.
     Format it exactly like Shopify's own `money` filter (learned from a sample Shopify printed on the page) and
     NEVER multiply by an exchange rate: Taiga's Woolman.Utils.formatMoney does, which turned $124.99 into
     $3,904.45 wherever the currency rate isn't 1. Do not swap this back to Woolman's helper. */
  AS.moneyFormat = (function () {
    var fallback = { pre: '$', post: '', thou: ',', dec: '.', places: 2 };
    var raw = window.AS_MONEY_SAMPLE;
    if (typeof raw !== 'string') return fallback;
    var t = document.createElement('textarea'); t.innerHTML = raw; raw = t.value.trim();
    var m = raw.match(/^([^0-9]*)([0-9][0-9.,\s\u00a0\u202f']*[0-9])(.*)$/);
    if (!m) return fallback;
    var num = m[2], seps = num.replace(/[0-9]/g, '').split(''), f = { pre: m[1], post: m[3], thou: '', dec: '.', places: 0 };
    var lastSep = seps.length ? seps[seps.length - 1] : '', tail = lastSep ? num.slice(num.lastIndexOf(lastSep) + 1) : '';
    if (seps.length && tail.length !== 3) { f.dec = lastSep; f.places = tail.length; if (seps.length > 1) f.thou = seps[0]; }
    else if (seps.length) { f.thou = seps[0]; }
    return f;
  })();
  AS.money = function (cents) {
    var f = AS.moneyFormat, n = Number(cents);
    if (!isFinite(n)) return '';
    var fixed = (Math.round(n) / 100).toFixed(f.places).split('.');
    var whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, f.thou);
    return f.pre + whole + (f.places ? f.dec + fixed[1] : '') + f.post;
  };
  /* money:end */
  AS.json = function (el) {
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  };

  /* ---------- cart ---------- */
  AS.updateCount = function () {
    return fetch((window.routes ? routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // leave the shipping protection add-on out of the count
        var cc = AS.json($('script[data-cart-cfg]')) || {}, n = 0;
        (cart.items || []).forEach(function (i) { if (i.variant_id !== cc.protection) n += i.quantity; });
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = n;
          el.hidden = n === 0;
        });
        return cart;
      })
      .catch(function () {});
  };
  // Timesact pre-order plans by variant id: set by the product page and kit builder, or read from data-sp on a button
  AS.sp = AS.sp || {};
  function planFor(id) {
    if (AS.sp[id]) return AS.sp[id];
    var b = document.querySelector('[data-sp-v="' + id + '"]');
    return b ? parseInt(b.getAttribute('data-sp'), 10) : null;
  }
  // items: [{id, quantity}]
  AS.addToCart = function (items) {
    items = items.map(function (it) { if (!it.selling_plan) { var sp = planFor(it.id); if (sp) it.selling_plan = sp; } return it; });
    var url = (window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) throw new Error(json.description || json.message || 'Could not add to bag');
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: json }));
        // Open the AquaStash bag; on the cart page (no bag) refresh the page list; otherwise go to the cart
        if (AS.cart && AS.cart.el) AS.cart.open(true);
        else if (AS.cart && AS.cart.page) AS.cart.refresh();
        else { AS.updateCount(); window.location.href = (window.routes ? routes.cart_url : '/cart'); }
        return json;
      });
    });
  };
  document.addEventListener('cart:update', AS.updateCount);

  /* ---------- slide-out bag (and the cart page, which uses the same list) ---------- */
  AS.cart = (function () {
    var api = {}, el = $('[data-as-cart]'), page = $('[data-as-cart-page]'), root = el || page;
    if (!root) return api;
    api.el = el; api.page = page;
    var cfg = AS.json($('script[data-cart-cfg]', root)) || {};
    var body = $('[data-cart-body]', root), foot = $('[data-cart-foot]', root), prot = $('[data-cart-prot]', root);
    var busy = false, lastFocus = null, state = null;
    var R = (window.routes && routes.root) || '/';
    function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
    function img(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
    function post(path, data) {
      return fetch(R + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong'); return j; }); });
    }
    function get() { return fetch(R + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
    function count(cart) {
      var n = 0; cart.items.forEach(function (i) { if (i.variant_id !== cfg.protection) n += i.quantity; });
      return n;
    }
    function render(cart) {
      state = cart;
      var items = cart.items.filter(function (i) { return i.variant_id !== cfg.protection; });
      var n = count(cart), hasProt = cart.items.some(function (i) { return i.variant_id === cfg.protection; });
      $$('[data-cart-count]').forEach(function (c) { c.textContent = n; c.hidden = n === 0; });
      var hc = $('[data-cart-head-count]', root); if (hc) hc.textContent = n ? '(' + n + ')' : '';
      // free shipping (AU only; threshold is 0 elsewhere). Protection doesn't count towards it.
      var goods = items.reduce(function (t, i) { return t + i.final_line_price; }, 0);
      var ship = $('[data-cart-ship]', root);
      if (ship) {
        ship.hidden = !(cfg.threshold > 0 && items.length);
        if (!ship.hidden) {
          var left = cfg.threshold - goods;
          $('[data-cart-ship-text]', ship).innerHTML = left > 0 ? 'You’re <strong>' + AS.money(left) + '</strong> away from free shipping' : '<strong>Free shipping</strong> unlocked';
          $('[data-cart-ship-bar]', ship).style.width = Math.max(4, Math.min(100, Math.round(goods / cfg.threshold * 100))) + '%';
        }
      }
      if (!items.length) {
        body.innerHTML = '<div class="as-cart__empty"><strong>Your bag is empty</strong><p>Everything we sell keeps your phone, keys and cards dry.</p>' +
          (cfg.shop || []).map(function (l) { return '<a class="as-btn as-btn--navy as-btn--block" href="' + esc(l.u) + '">' + esc(l.t) + '</a>'; }).join('') + '</div>';
        if (foot) foot.hidden = true;
        return;
      }
      var html = '<ul class="as-cart__list">' + items.map(function (i) {
        var opts = (i.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return esc(o.value); }).join(' · ');
        var was = i.original_line_price > i.final_line_price ? ' <s><span class="as-visually-hidden">Was </span>' + AS.money(i.original_line_price) + '</s>' : '';
        var disc = (i.line_level_discount_allocations || []).map(function (d) { return '<small class="as-cart__disc">' + esc(d.discount_application.title) + ' (−' + AS.money(d.amount) + ')</small>'; }).join('');
        return '<li class="as-cart__item" data-key="' + esc(i.key) + '">' +
          '<a class="as-cart__img" href="' + esc(i.url) + '" tabindex="-1" aria-hidden="true">' + (i.image ? '<img src="' + esc(img(i.image, 200)) + '" alt="" width="88" height="110" loading="lazy">' : '') + '</a>' +
          '<div class="as-cart__info"><a class="as-cart__name" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' +
          (opts ? '<small>' + opts + '</small>' : '') + disc +
          (i.selling_plan_allocation && i.selling_plan_allocation.selling_plan ? '<small class="as-cart__pre">' + esc(i.selling_plan_allocation.selling_plan.description || i.selling_plan_allocation.selling_plan.name) + '</small>' : '') +
          '<div class="as-cart__row"><div class="as-cart__qty" role="group" aria-label="Quantity">' +
          '<button type="button" data-qty="' + (i.quantity - 1) + '" aria-label="One fewer ' + esc(i.product_title) + '">−</button><span>' + i.quantity + '</span>' +
          '<button type="button" data-qty="' + (i.quantity + 1) + '" aria-label="One more ' + esc(i.product_title) + '">+</button></div>' +
          '<span class="as-cart__price">' + AS.money(i.final_line_price) + was + '</span></div>' +
          '<button type="button" class="as-cart__rm" data-qty="0">Remove</button></div></li>';
      }).join('') + '</ul>';
      var up = cfg.upsell;
      if (up && !cart.items.some(function (i) { return i.variant_id === up.id; })) {
        html += '<div class="as-cart__up"><span class="as-cart__label">Add to your order</span><div class="as-cart__upcard">' +
          (up.image ? '<img src="' + esc(up.image) + '" alt="" width="64" height="64" loading="lazy">' : '') +
          '<div><a href="' + esc(up.url) + '">' + esc(up.title) + '</a>' + (up.note ? '<small>' + esc(up.note) + '</small>' : '') + '<b>' + AS.money(up.price) + '</b></div>' +
          '<button type="button" class="as-btn as-btn--navy" data-cart-up>Add</button></div></div>';
      }
      body.innerHTML = html;
      if (foot) foot.hidden = false;
      if (prot) prot.checked = hasProt;
      var tot = $('[data-cart-total]', root); if (tot) tot.textContent = AS.money(cart.total_price);
    }
    function change(key, qty) {
      if (busy) return; busy = true; root.classList.add('is-busy');
      return post('cart/change.js', { id: key, quantity: qty }).then(render).catch(function (e) { alert(e.message); })
        .then(function () { busy = false; root.classList.remove('is-busy'); });
    }
    api.refresh = function () { return get().then(render); };
    api.open = function (fresh) {
      if (!el) return;
      lastFocus = document.activeElement;
      el.hidden = false;
      requestAnimationFrame(function () { el.classList.add('is-open'); });
      document.documentElement.classList.add('as-cart-on');
      $('.as-cart__panel', el).focus();
      if (fresh || !state) api.refresh();
    };
    api.close = function () {
      if (!el || el.hidden) return;
      el.classList.remove('is-open');
      document.documentElement.classList.remove('as-cart-on');
      setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, 350);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    root.addEventListener('click', function (e) {
      var q = e.target.closest('[data-qty]');
      if (q) { change(q.closest('[data-key]').getAttribute('data-key'), parseInt(q.getAttribute('data-qty'), 10)); return; }
      if (e.target.closest('[data-cart-close]')) { api.close(); return; }
      var u = e.target.closest('[data-cart-up]');
      if (u && cfg.upsell && !busy) {
        busy = true; u.classList.add('is-loading');
        post('cart/add.js', { items: [{ id: cfg.upsell.id, quantity: 1 }] }).then(api.refresh).catch(function (er) { alert(er.message); }).then(function () { busy = false; });
      }
    });
    if (prot) prot.addEventListener('change', function () {
      if (busy || !state) return; busy = true;
      var line = state.items.filter(function (i) { return i.variant_id === cfg.protection; })[0];
      var p = prot.checked ? (line ? Promise.resolve() : post('cart/add.js', { items: [{ id: cfg.protection, quantity: 1 }] }))
        : (line ? post('cart/change.js', { id: line.key, quantity: 0 }) : Promise.resolve());
      p.then(api.refresh).catch(function (er) { alert(er.message); }).then(function () { busy = false; });
    });
    if (el) {
      document.addEventListener('click', function (e) {
        var o = e.target.closest('[data-as-cart-open], a[href="#drawer-cart"]');
        if (!o) return;
        e.preventDefault();
        if (typeof window.closeAsDrawer === 'function') window.closeAsDrawer();
        api.open(true);
      });
      document.addEventListener('keydown', function (e) {
        if (el.hidden) return;
        if (e.key === 'Escape') api.close();
        if (e.key === 'Tab') {
          var f = $$('a[href], button:not([disabled]), input', el).filter(function (x) { return x.offsetParent !== null; });
          if (!f.length) return;
          if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
          else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
        }
      });
    }
    if (page) api.refresh();
    return api;
  })();
  document.addEventListener('cart:refresh', function () { if (AS.cart.refresh) AS.cart.refresh(); });

  /* ---------- header: mega menu and mobile drawer ---------- */
  function initHeader() {
    var header = $('[data-as-header]');
    if (!header) return;
    var mega = $('[data-mega]', header), dim = $('[data-mega-dim]');
    var navBtns = $$('[data-mega-open]', header);
    var closeT, shownT;
    function openMega(id) {
      if (!mega) return;
      clearTimeout(closeT);
      var panel = $('[data-mega-panel="' + id + '"]', mega);
      if (!panel) { closeMega(); return; }
      var already = mega.classList.contains('is-open') && panel.classList.contains('is-current');
      navBtns.forEach(function (b) { b.setAttribute('aria-expanded', b.getAttribute('data-mega-open') === id ? 'true' : 'false'); });
      if (already) return;
      $$('[data-mega-panel]', mega).forEach(function (p) { p.classList.toggle('is-current', p === panel); });
      mega.classList.remove('is-shown');
      mega.classList.add('is-open');
      if (dim) dim.classList.add('is-on');
      clearTimeout(shownT);
      shownT = setTimeout(function () { mega.classList.add('is-shown'); }, 40);
    }
    function closeMega() {
      if (!mega) return;
      mega.classList.remove('is-open', 'is-shown');
      if (dim) dim.classList.remove('is-on');
      navBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    navBtns.forEach(function (b) {
      var id = b.getAttribute('data-mega-open');
      b.addEventListener('mouseenter', function () { openMega(id); });
      b.addEventListener('focus', function () { openMega(id); });
      b.addEventListener('click', function (e) {
        if (!$('[data-mega-panel="' + id + '"]', mega)) { if (b.getAttribute('data-href')) window.location.href = b.getAttribute('data-href'); return; }
        e.preventDefault();
        if (b.getAttribute('aria-expanded') === 'true') closeMega(); else openMega(id);
      });
    });
    header.addEventListener('mouseleave', function () { closeT = setTimeout(closeMega, 180); });
    header.addEventListener('mouseenter', function () { clearTimeout(closeT); });
    if (dim) dim.addEventListener('click', closeMega);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeMega(); closeDrawer(); } });

    var drawer = $('[data-as-drawer]');
    var opener = null;
    function openDrawer(e) {
      if (!drawer) return;
      opener = e && e.currentTarget;
      drawer.classList.add('is-open');
      drawer.classList.remove('is-sub');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      var first = $('button, a', drawer); if (first) setTimeout(function () { first.focus(); }, 300);
    }
    window.closeAsDrawer = function () { closeDrawer(); };
    function closeDrawer() {
      if (!drawer || !drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open', 'is-sub');
      document.documentElement.style.overflow = '';
      if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); opener = null; }
    }
    $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openDrawer(e); }); });
    $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); closeDrawer(); }); });
    $$('[data-drawer-sub]').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-drawer-sub');
        $$('[data-drawer-pane]', drawer).forEach(function (p) { p.classList.toggle('is-current', p.getAttribute('data-drawer-pane') === id); });
        drawer.classList.add('is-sub');
        var back = $('[data-drawer-pane="' + id + '"] [data-drawer-back]', drawer); if (back) setTimeout(function () { back.focus(); }, 350);
      });
    });
    $$('[data-drawer-back]').forEach(function (b) { b.addEventListener('click', function () { drawer.classList.remove('is-sub'); }); });
  }

  /* ---------- quick add on product cards ---------- */
  function initQuickAdd(root) {
    $$('[data-quick]', root).forEach(function (q) {
      if (q._as) return; q._as = true;
      var openBtn = $('[data-quick-open]', q);
      if (openBtn) openBtn.addEventListener('click', function () {
        var open = q.classList.toggle('is-open');
        openBtn.classList.toggle('is-open', open);
        openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        openBtn.textContent = open ? 'Choose a size' : 'Quick add';
      });
      $$('[data-quick-add]', q).forEach(function (b) {
        b.addEventListener('click', function () {
          var btn = openBtn || b;
          b.disabled = true;
          AS.addToCart([{ id: parseInt(b.getAttribute('data-quick-add'), 10), quantity: 1 }])
            .then(function () {
              q.classList.remove('is-open');
              btn.classList.add('is-added'); btn.classList.remove('is-open');
              btn.textContent = 'Added to bag';
              setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = openBtn ? 'Quick add' : 'Add to bag'; }, 2500);
            })
            .catch(function (err) { btn.textContent = err.message; })
            .then(function () { b.disabled = false; });
        });
      });
    });
  }

  /* ---------- product page ---------- */
  var PHONES = {
    ip16pm: ['iPhone 16 Pro Max', 163, 77.6], ip15pm: ['iPhone 15 Pro Max', 159.9, 76.7], ip15plus: ['iPhone 15 Plus', 160.9, 77.8],
    ip15: ['iPhone 15 / 15 Pro', 147.6, 71.6], ip14: ['iPhone 14 / 13 / 12', 146.7, 71.5],
    s24u: ['Galaxy S24 Ultra', 162.3, 79], s24p: ['Galaxy S24+', 158.5, 75.9], s24: ['Galaxy S24', 147, 70.6], s23: ['Galaxy S23 / S22', 146.3, 70.9],
    px8p: ['Pixel 8 Pro', 162.6, 76.5], px8: ['Pixel 8', 150.5, 70.8], px7: ['Pixel 7', 155.6, 73.2],
    zfold: ['Galaxy Z Fold 5 (open)', 154.9, 129.9], pxfold: ['Pixel Fold (open)', 139.7, 158.7]
  };
  AS.PHONES = PHONES;
  var CHARTS = {
    womens: { kind: 'au', q: 'Your usual AU dress size', opts: ['6', '8', '10', '12', '14', '16', '18', '20'], sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'],
      rows: { XS: [6, 62, 90, 94], S: [8, 67, 95, 99], M: [10, 72, 100, 104], L: [12, 77, 105, 109], XL: [14, 82, 110, 114], '2XL': [16, 87, 115, 119], '3XL': [18, 92, 120, 124], '4XL': [20, 97, 125, 129] },
      // outer leg, inner leg (cm) from the 2026 size charts
      len: { short: { XS: [30.6, 8.1], S: [31.3, 8.8], M: [32, 9.5], L: [32.7, 10.2], XL: [33.4, 10.9], '2XL': [34.1, 11.6], '3XL': [34.8, 12.3] },
        mid: { XS: [33, 15], S: [34, 15], M: [35, 15], L: [36, 15], XL: [37, 15], '2XL': [38, 15], '3XL': [39, 15], '4XL': [40, 15] } },
      over: 'That needs a 4XL, which comes in The Pass mid length.' },
    mens: { kind: 'waist', q: 'Your usual waist size (inches)', opts: ['28', '30', '32', '34', '36', '38', '40'], sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'],
      rows: { XS: [28, 73, 97], S: [30, 78, 102], M: [32, 83, 107], L: [34, 88, 112], XL: [36, 93, 117], '2XL': [38, 98, 122], '3XL': [40, 103, 127] },
      len: { mens: { XS: [38, 13], S: [39.5, 13.5], M: [41, 14], L: [42.5, 14.5], XL: [44, 15], '2XL': [45.5, 15.5], '3XL': [47, 16] } },
      over: 'That’s past our biggest size (3XL, up to 108cm waist).' }
  };
  AS.CHARTS = CHARTS;
  var normSize = function (s) { return String(s).replace('XXXL', '3XL').replace('XXL', '2XL'); };

  function initProduct(root) {
    var cfgEl = $('script[data-as-product]', root);
    if (!cfgEl) return;
    var cfg = AS.json(cfgEl);
    if (!cfg) return;
    cfg.variants.forEach(function (v) { if (v.pre && v.sp) AS.sp[v.id] = v.sp; });
    var form = $('[data-as-form]', root);
    var state = { options: (cfg.current || []).slice(), kit: {}, sizeChosen: !cfg.sizeIndexRequiresChoice };
    var sizeIdx = cfg.sizeIndex;
    // A size must be picked by the shopper before we add to bag (no silent default size)
    if (sizeIdx >= 0 && !cfg.preselected) state.options[sizeIdx] = null;

    function findVariant() {
      for (var i = 0; i < cfg.variants.length; i++) {
        var v = cfg.variants[i], ok = true;
        for (var j = 0; j < v.options.length; j++) { if (state.options[j] !== null && state.options[j] !== v.options[j]) { ok = false; break; } }
        if (ok && state.options.indexOf(null) === -1) return v;
      }
      return null;
    }
    function firstForOption(j, val) {
      for (var i = 0; i < cfg.variants.length; i++) if (cfg.variants[i].options[j] === val) return cfg.variants[i];
      return null;
    }
    var current = findVariant();

    function availabilityFor(j, val) {
      // available if some variant with this value (and other chosen options) is available
      return cfg.variants.some(function (v) {
        if (v.options[j] !== val || !v.available) return false;
        for (var k = 0; k < v.options.length; k++) { if (k !== j && state.options[k] !== null && state.options[k] !== v.options[k] && k !== sizeIdx) return false; }
        return true;
      });
    }

    function render() {
      current = findVariant();
      // option buttons
      var colourName = cfg.colourIndex >= 0 ? state.options[cfg.colourIndex] : '';
      $$('[data-opt]', root).forEach(function (b) {
        var j = parseInt(b.getAttribute('data-opt'), 10), val = b.getAttribute('data-val');
        var on = state.options[j] === val;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (b.classList.contains('as-pill')) {
          // sold-out sizes are crossed out and can't be picked, for the colour on show
          var out = !availabilityFor(j, val);
          b.classList.toggle('is-out', out);
          b.disabled = out;
          var isPre = !out && cfg.variants.some(function (v) { return v.pre && v.options[j] === val && (cfg.colourIndex < 0 || v.options[cfg.colourIndex] === colourName); });
          b.classList.toggle('is-pre', isPre);
          if (out) b.setAttribute('aria-label', normSize(val) + ', sold out' + (colourName ? ' in ' + colourName : '')); else if (isPre) b.setAttribute('aria-label', normSize(val) + ', pre-order'); else b.removeAttribute('aria-label');
        }
      });
      $$('[data-opt-label]', root).forEach(function (el) {
        var j = parseInt(el.getAttribute('data-opt-label'), 10);
        el.textContent = state.options[j] !== null ? normSize(state.options[j]) : (j === sizeIdx ? 'choose one' : '');
      });
      var refV = current || firstForOption(0, state.options[0]) || cfg.variants[0];
      // price
      var priceEl = $('[data-price]', root), cmpEl = $('[data-compare]', root);
      if (priceEl) priceEl.textContent = AS.money(refV.price);
      if (cmpEl) { cmpEl.textContent = refV.compare > refV.price ? AS.money(refV.compare) : ''; cmpEl.hidden = !(refV.compare > refV.price); }
      // form id
      if (form) $('[name="id"]', form).value = current ? current.id : '';
      // stock
      var stockEl = $('[data-stock]', root);
      if (stockEl) {
        // real stock only: "Only N left" at 5 or fewer for the chosen size; "Last sizes" when a colour is down to one or two
        var limit = Math.min(cfg.lowStock || 5, 5), text = '';
        if (current && current.tracked && current.inventory > 0 && current.inventory <= limit) {
          text = 'Only ' + current.inventory + ' left' + (sizeIdx >= 0 ? ' in ' + normSize(current.options[sizeIdx]) : (colourName ? ' in ' + colourName : ''));
        } else if (sizeIdx >= 0 && state.options[sizeIdx] === null) {
          var left = [];
          cfg.variants.forEach(function (v) { if (v.available && (cfg.colourIndex < 0 || v.options[cfg.colourIndex] === colourName) && left.indexOf(normSize(v.options[sizeIdx])) === -1) left.push(normSize(v.options[sizeIdx])); });
          if (left.length > 0 && left.length <= 2) text = 'Last sizes' + (colourName ? ' in ' + colourName : '') + ': ' + left.join(', ');
        }
        stockEl.hidden = !text;
        stockEl.textContent = text;
      }
      // kit + totals
      var items = 1, sub = refV.price;
      $$('[data-kit]', root).forEach(function (t) {
        var on = !!state.kit[t.getAttribute('data-kit')];
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        t.setAttribute('aria-label', (on ? 'Remove ' : 'Add ') + t.getAttribute('data-name'));
        if (on) { items += 1; sub += parseInt(t.getAttribute('data-price'), 10); }
      });
      var pct = 0;
      (cfg.tiers || []).forEach(function (tier) { if (items >= tier[0]) pct = tier[1]; });
      var total = Math.round(sub * (1 - pct / 100));
      var kitNote = $('[data-kit-note]', root);
      if (kitNote) kitNote.textContent = items > 1 ? pct + '% off your kit' : (cfg.tiers && cfg.tiers[0] ? 'Add one, save ' + cfg.tiers[0][1] + '%' : '');
      var needSize = sizeIdx >= 0 && state.options[sizeIdx] === null;
      var avail = current ? current.available : true;
      var cta = $('[data-cta]', root), barCta = $('[data-bar-cta]', root);
      // pre-order: the Timesact plan's message (or the product's pre-order notice) shows before they order
      var pre = !!(current && current.pre), preBox = $('[data-preorder]', root);
      var preMsg = function (v) { return (v && v.spMsg) || cfg.preNotice || 'Ships as soon as new stock lands.'; };
      var anyPre = cfg.variants.filter(function (v) { return v.pre && (cfg.colourIndex < 0 || v.options[cfg.colourIndex] === colourName); });
      if (preBox) {
        var showV = pre ? current : (needSize && anyPre.length ? anyPre[0] : null);
        preBox.hidden = !showV;
        if (showV) {
          $('[data-preorder-head]', preBox).textContent = pre ? 'Pre-order' : (anyPre.length === cfg.variants.filter(function (v) { return v.available && (cfg.colourIndex < 0 || v.options[cfg.colourIndex] === colourName); }).length ? 'Pre-order' : 'Some sizes are on pre-order');
          $('[data-preorder-msg]', preBox).textContent = preMsg(showV);
        }
      }
      var label = needSize ? 'Choose your size' : (!avail ? 'Sold out' : (pre ? 'Pre-order now, ' : 'Add to bag, ') + AS.money(total));
      if (cta) { cta.textContent = label; cta.setAttribute('aria-disabled', !needSize && !avail ? 'true' : 'false'); }
      if (barCta) barCta.textContent = needSize ? 'Choose size' : (!avail ? 'Sold out' : (pre ? 'Pre-order now' : 'Add to bag'));
      var barLine = $('[data-bar-line]', root), barTotal = $('[data-bar-total]', root);
      if (barLine) barLine.textContent = (colourName || cfg.short) + (sizeIdx >= 0 && state.options[sizeIdx] ? ', ' + normSize(state.options[sizeIdx]) : '') + (items > 1 ? ' + ' + (items - 1) + ' more' : '');
      if (barTotal) barTotal.textContent = AS.money(total);
      // free shipping meter
      var thr = cfg.freeShipping || 0;
      if (thr) {
        var cartNow = cfg.cartTotal || 0, after = cartNow + total;
        var shipText = $('[data-ship-text]', root), shipBar = $('[data-ship-bar]', root);
        if (shipText) shipText.textContent = after >= thr ? 'Free shipping unlocked' : AS.money(thr - after) + ' away from free shipping';
        if (shipBar) shipBar.style.width = Math.min(100, Math.round(after / thr * 100)) + '%';
      }
      // gallery: jump to the colour's photo
      var mediaV = current || refV;
      if (mediaV && mediaV.media && root._lastMedia !== mediaV.media) {
        var first = root._lastMedia === undefined;
        root._lastMedia = mediaV.media;
        if (!first) showMedia(mediaV.media);
      }
      // url
      if (current && window.history && history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', current.id); history.replaceState({}, '', u.toString());
      }
      // size chart highlight
      var hi = state.options[sizeIdx] ? normSize(state.options[sizeIdx]) : (finder && finder.rec);
      $$('[data-chart-row]', root).forEach(function (r) { r.classList.toggle('is-hi', r.getAttribute('data-chart-row') === hi); });
    }

    $$('[data-opt]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        var j = parseInt(b.getAttribute('data-opt'), 10);
        state.options[j] = b.getAttribute('data-val');
        // a new colour can sell out the size already picked: clear it rather than add a sold-out size
        if (j !== sizeIdx && sizeIdx >= 0 && state.options[sizeIdx] !== null && !availabilityFor(sizeIdx, state.options[sizeIdx])) state.options[sizeIdx] = null;
        var err = $('[data-error]', root); if (err) err.hidden = true;
        render();
      });
    });
    $$('[data-kit]', root).forEach(function (t) {
      t.addEventListener('click', function () { var k = t.getAttribute('data-kit'); state.kit[k] = !state.kit[k]; render(); });
    });

    // size finder
    var finder = null;
    var fEl = $('[data-finder]', root);
    var fToggle = $('[data-finder-toggle]', root);
    if (fEl && fToggle) fToggle.addEventListener('click', function () {
      var open = fEl.classList.toggle('is-open');
      fToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      var lbl = $('[data-finder-label]', fToggle); if (lbl) lbl.textContent = open ? 'Close size guide' : 'Size guide: find your size';
    });
    function closeFinder() { fEl.classList.remove('is-open'); if (fToggle) { var lbl = $('[data-finder-label]', fToggle); if (lbl) lbl.textContent = 'Size guide: find your size'; fToggle.setAttribute('aria-expanded', 'false'); } }
    function sizeState(size, norm) {
      var exists = !!size && cfg.variants.some(function (v) { return (norm ? normSize(v.options[sizeIdx]) : v.options[sizeIdx]) === size; });
      var inStock = exists && cfg.variants.some(function (v) { return v.available && (norm ? normSize(v.options[sizeIdx]) : v.options[sizeIdx]) === size; });
      return { exists: exists, inStock: inStock };
    }
    function useSize(size, norm) {
      var match = null;
      cfg.variants.forEach(function (v) { if (!match && (norm ? normSize(v.options[sizeIdx]) : v.options[sizeIdx]) === size) match = v.options[sizeIdx]; });
      if (match) { state.options[sizeIdx] = match; closeFinder(); render(); }
    }
    // Waist-range sizes (Dry Pocket "30-33", Randy Cow letters): the chart comes from the product itself
    if (fEl && fEl.getAttribute('data-finder') === 'range') {
      var R = AS.json($('script[data-ranges]', fEl)), rf = { fit: 'relaxed', unit: 'in', rec: null }; // no fit question: where two sizes cover the waist, take the larger so the pocket doesn't dig in
      var fsel = $('[data-fsel]', fEl);
      var drawRange = function () {
        var w = +fsel.value, fits = R.filter(function (r) { return w >= r.lo && w <= r.hi; });
        var pick = fits.length ? (rf.fit === 'relaxed' ? fits[fits.length - 1] : fits[0]) : R.filter(function (r) { return r.lo > w; })[0] || null;
        rf.rec = pick ? pick.s : null;
        $('[data-rec]', fEl).textContent = pick ? 'We’d go ' + pick.s : 'That’s off our chart';
        var alt = fits.length > 1 ? fits[0] : null;
        rf.alt = alt ? alt.s : null;
        var why = !pick ? 'That’s past our biggest size (' + R[R.length - 1].hi + 'in waist).'
          : alt ? w + 'in sits in both ' + alt.s + ' and ' + pick.s + '. We’d go up to ' + pick.s + ' so the pocket’s magnetic seal doesn’t dig in, as long as the waist won’t be too wide. ' + alt.s + ' also fits if you like it snugger.'
          : fits.length ? pick.s + ' fits a ' + pick.lo + '–' + pick.hi + 'in waist.' : 'Your waist sits between sizes, so we’d go up to ' + pick.s + ' (' + pick.lo + '–' + pick.hi + 'in).';
        var st = sizeState(pick && pick.s), sa = sizeState(rf.alt);
        if (st.exists && !st.inStock) why += ' ' + pick.s + ' is sold out in this style right now.';
        if (sa.exists && !sa.inStock) why += ' ' + rf.alt + ' is sold out in this style right now.';
        $('[data-rec-why]', fEl).textContent = why;
        var use = $('[data-rec-use]', fEl); use.hidden = !st.inStock; use.textContent = 'Choose ' + (rf.rec || '');
        var altB = $('[data-rec-alt]', fEl); if (altB) { altB.hidden = !sa.inStock; altB.textContent = 'Choose ' + (rf.alt || ''); }
        $$('[data-ffit]', fEl).forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-ffit') === rf.fit); });
        var cm = rf.unit === 'cm', u = function (v) { return cm ? Math.round(v * 2.54) : v; };
        $$('[data-unit-label]', fEl).forEach(function (el) { el.textContent = rf.unit; });
        $('[data-unit]', fEl).textContent = cm ? 'Show inches' : 'Show cm';
        $$('[data-chart-row]', fEl).forEach(function (row) {
          var r = R.filter(function (x) { return x.s === row.getAttribute('data-chart-row'); })[0]; if (!r) return;
          row.children[1].textContent = u(r.lo) + '–' + u(r.hi);
          row.classList.toggle('is-hi', r.s === rf.rec);
        });
      };
      fsel.addEventListener('change', drawRange);
      $$('[data-ffit]', fEl).forEach(function (b) { b.addEventListener('click', function () { rf.fit = b.getAttribute('data-ffit'); drawRange(); }); });
      $('[data-unit]', fEl).addEventListener('click', function () { rf.unit = rf.unit === 'cm' ? 'in' : 'cm'; drawRange(); });
      $('[data-rec-use]', fEl).addEventListener('click', function () { if (rf.rec) useSize(rf.rec); });
      if ($('[data-rec-alt]', fEl)) $('[data-rec-alt]', fEl).addEventListener('click', function () { if (rf.alt) useSize(rf.alt); });
      drawRange();
    } else if (fEl && CHARTS[fEl.getAttribute('data-finder')]) {
      var C = CHARTS[fEl.getAttribute('data-finder')], LEN = C.len[fEl.getAttribute('data-len')] || {};
      var SZ = Object.keys(LEN).length ? Object.keys(LEN) : C.sizes;
      var fcm = $('[data-fcm]', fEl);
      finder = { mode: 'usual', v: null, unit: 'cm', rec: null, alt: null };
      var aN = function (w) { return (/^(8|11|18)/.test(String(w)) ? 'an ' : 'a ') + w + 'cm waist'; };
      var cmTxt = function (v) { return v + 'cm (' + (v / 2.54).toFixed(1) + 'in)'; };
      var lo = function (z) { return C.rows[z][1]; };
      // the smallest size that fits the waist; on a boundary offer the size either side
      var fromWaist = function (w) {
        var rec = null, alt = null;
        if (C.kind === 'au') {
          for (var i = 0; i < SZ.length; i++) if (lo(SZ[i]) >= w) { rec = SZ[i]; break; }
          if (rec) { var k = SZ.indexOf(rec); if (k > 0 && w > lo(SZ[k - 1]) && w - lo(SZ[k - 1]) <= 3) alt = SZ[k - 1]; if (lo(rec) === w && SZ[k + 1]) alt = SZ[k + 1]; }
        } else {
          for (var j = 0; j < SZ.length; j++) if (w >= lo(SZ[j]) && w <= lo(SZ[j]) + 5) { rec = SZ[j]; }
          if (rec) { var m = SZ.indexOf(rec); if (m > 0 && w === lo(rec)) alt = SZ[m - 1]; }
          else if (w < lo(SZ[0])) rec = SZ[0];
        }
        return { rec: rec, alt: alt };
      };
      var dims = function (z) {
        var r = C.rows[z], l = LEN[z], out = [];
        if (C.kind === 'au') { out.push(['Waist relaxed', cmTxt(r[1])], ['Waist stretched', cmTxt(r[2])], ['Hip', cmTxt(r[3])]); }
        else { out.push(['Waist', r[1] + '–' + (r[1] + 5) + 'cm (' + (r[1] / 2.54).toFixed(1) + '–' + ((r[1] + 5) / 2.54).toFixed(1) + 'in), stretches about 10cm more'], ['Hip', cmTxt(r[2])]); }
        if (l) out.push(['Outer leg length', cmTxt(l[0])], ['Inner leg length', cmTxt(l[1])]);
        return out.map(function (d) { return '<dt>' + d[0] + '</dt><dd>' + d[1] + '</dd>'; }).join('');
      };
      var drawFinder = function () {
        var res = { rec: null, alt: null }, why = '';
        if (finder.mode === 'measure') {
          var w = +fcm.value; res = fromWaist(w);
          why = !res.rec ? 'That’s past the waist of our biggest size in this style (' + SZ[SZ.length - 1] + ', ' + lo(SZ[SZ.length - 1]) + (C.kind === 'au' ? 'cm relaxed' : '–' + (lo(SZ[SZ.length - 1]) + 5) + 'cm') + '). Email info@aquastash.com.au and we’ll help.' : res.alt
            ? 'A' + aN(w).slice(1) + ' sits between ' + (SZ.indexOf(res.alt) < SZ.indexOf(res.rec) ? res.alt + ' and ' + res.rec : res.rec + ' and ' + res.alt) + '. Between sizes, go up so long as the waist won’t be too wide.'
            : 'Based on ' + aN(w) + '.';
        } else if (finder.v) {
          var i = C.opts.indexOf(finder.v); res.rec = SZ[i] || null;
          why = !res.rec ? C.over : C.kind === 'au' ? res.rec + ' is our AU ' + finder.v + '. Sizing varies between brands, so check the measurements below.' : res.rec + ' suits a ' + finder.v + 'in waist. Sizing varies between brands, so check the measurements below.';
        }
        finder.rec = res.rec; finder.alt = res.alt;
        var rec = $('[data-rec]', fEl), recBox = $('.as-finder__rec', fEl);
        recBox.hidden = finder.mode === 'usual' && !finder.v;
        rec.textContent = finder.rec ? 'We recommend ' + finder.rec : 'That’s off our chart';
        var st = sizeState(finder.rec, true), sa = sizeState(finder.alt, true);
        if (st.exists && !st.inStock) why += ' ' + finder.rec + ' is sold out in this style right now.';
        if (sa.exists && !sa.inStock) why += ' ' + finder.alt + ' is sold out in this style right now.';
        $('[data-rec-why]', fEl).textContent = why;
        $('[data-rec-dims]', fEl).innerHTML = finder.rec ? '<dt class="as-finder__dimh">' + finder.rec + ' measurements</dt>' + dims(finder.rec) : '';
        var use = $('[data-rec-use]', fEl); use.hidden = !st.inStock; use.textContent = 'Choose ' + (finder.rec || '');
        var altB = $('[data-rec-alt]', fEl); altB.hidden = !sa.inStock; altB.textContent = 'Choose ' + (finder.alt || '');
        $$('[data-fv]', fEl).forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-fv') === finder.v); });
        $$('[data-fmode]', fEl).forEach(function (b) { var on = b.getAttribute('data-fmode') === finder.mode; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
        $$('[data-fpanel]', fEl).forEach(function (p) { p.hidden = p.getAttribute('data-fpanel') !== finder.mode; });
        var cm = finder.unit === 'cm', u = function (v) { return cm ? String(v) : (v / 2.54).toFixed(1); };
        $$('[data-unit-label]', fEl).forEach(function (el) { el.textContent = finder.unit; });
        $('[data-unit]', fEl).textContent = cm ? 'Show inches' : 'Show cm';
        $$('[data-chart-row]', fEl).forEach(function (r) {
          var z = r.getAttribute('data-chart-row'), c = C.rows[z]; if (!c) return;
          var cells = r.children;
          if (C.kind === 'au') { cells[1].textContent = u(c[1]) + '–' + u(c[2]); cells[2].textContent = u(c[3]); }
          else { cells[1].textContent = u(c[1]) + '–' + u(c[1] + 5); cells[2].textContent = u(c[2]); }
          r.classList.toggle('is-hi', z === finder.rec);
        });
        render();
      };
      $$('[data-fv]', fEl).forEach(function (b) { b.addEventListener('click', function () { finder.v = b.getAttribute('data-fv'); drawFinder(); }); });
      $$('[data-fmode]', fEl).forEach(function (b) { b.addEventListener('click', function () { finder.mode = b.getAttribute('data-fmode'); drawFinder(); }); });
      if (fcm) fcm.addEventListener('change', drawFinder);
      $('[data-unit]', fEl).addEventListener('click', function () { finder.unit = finder.unit === 'cm' ? 'in' : 'cm'; drawFinder(); });
      $('[data-rec-use]', fEl).addEventListener('click', function () { if (finder.rec) useSize(finder.rec, true); });
      $('[data-rec-alt]', fEl).addEventListener('click', function () { if (finder.alt) useSize(finder.alt, true); });
      drawFinder();
    }

    // gallery: phones scroll the photos; desktop shows one large photo and the thumbnails switch it
    function showMedia(id) {
      var slide = $('[data-media-id="' + id + '"]', root);
      if (!slide) return;
      $$('[data-media-id]', root).forEach(function (s) { s.classList.toggle('is-current', s === slide); });
      $$('[data-thumb]', root).forEach(function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-thumb') === String(id) ? 'true' : 'false'); });
      if (slide.parentElement && window.innerWidth < 990) slide.parentElement.scrollTo({ left: slide.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    $$('[data-thumb]', root).forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });
    var slides = $('[data-slides]', root);
    // arrows: phones scroll to the next photo; desktop switches the large photo (and keeps its thumbnail in view)
    $$('[data-gal-step]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var all = $$('[data-media-id]', root); if (!all.length) return;
        var step = +b.getAttribute('data-gal-step'), i;
        if (window.innerWidth < 990 && slides) i = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
        else i = all.findIndex(function (s) { return s.classList.contains('is-current'); });
        var n = (Math.max(0, i) + step + all.length) % all.length, id = all[n].getAttribute('data-media-id');
        showMedia(id);
        var th = $('[data-thumb="' + id + '"]', root); if (th && th.parentElement) th.parentElement.scrollTo({ left: th.offsetLeft - th.parentElement.clientWidth / 2 + th.clientWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    if (slides) {
      var dots = $$('[data-dot]', root);
      dots.forEach(function (d, i) { d.addEventListener('click', function () { var s = slides.children[i]; if (s) slides.scrollTo({ left: s.offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); }); });
      slides.addEventListener('scroll', function () {
        var i = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      }, { passive: true });
    }

    // add to bag (main button and sticky bar)
    function submit(e) {
      if (e) e.preventDefault();
      var err = $('[data-error]', root);
      if (sizeIdx >= 0 && state.options[sizeIdx] === null) {
        var pills = $('[data-size-pills]', root);
        if (pills) {
          pills.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
          pills.classList.remove('is-attn'); void pills.offsetWidth; pills.classList.add('is-attn');
          clearTimeout(pills._attn); pills._attn = setTimeout(function () { pills.classList.remove('is-attn'); }, 1800);
          var first = $('[data-opt]', pills); if (first) first.focus({ preventScroll: true });
        }
        if (err) { err.textContent = 'Pick a size first. Not sure? Use the size finder.'; err.hidden = false; }
        return;
      }
      current = findVariant();
      if (!current || !current.available) { if (err) { err.textContent = 'That one’s sold out. Try another size or colour.'; err.hidden = false; } return; }
      var items = [{ id: current.id, quantity: 1 }];
      $$('[data-kit]', root).forEach(function (t) { if (state.kit[t.getAttribute('data-kit')]) items.push({ id: parseInt(t.getAttribute('data-variant'), 10), quantity: 1 }); });
      var btns = $$('[data-cta], [data-bar-cta]', root);
      btns.forEach(function (b) { b.classList.add('is-loading'); });
      AS.addToCart(items)
        .then(function () { if (err) err.hidden = true; })
        .catch(function (ex) { if (err) { err.textContent = ex.message; err.hidden = false; } })
        .then(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); }); });
    }
    // The main button is a real submit button so the page works without JavaScript. Once this script runs it becomes a
    // plain button: cart apps (Upcart) listen for product-form submits and would add the default variant before we can
    // check a size was picked, opening the cart with an error.
    var mainBtn = $('[data-cta]', root);
    if (mainBtn) { mainBtn.type = 'button'; mainBtn.addEventListener('click', submit); }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); e.stopImmediatePropagation(); submit(); }, true);
    var barCta = $('[data-bar-cta]', root);
    if (barCta) barCta.addEventListener('click', submit);

    // sticky bar shows once the main button scrolls away
    var sticky = $('[data-sticky]', root), mainCta = $('[data-cta]', root);
    if (sticky && mainCta) {
      // A scroll check rather than an IntersectionObserver, so it is also right after a jump (reload mid-page, anchor links)
      var barTick = false;
      var barUpdate = function () { barTick = false; var on = mainCta.getBoundingClientRect().bottom < 0; sticky.classList.toggle('is-on', on); document.documentElement.classList.toggle('as-bar-on', on); };
      window.addEventListener('scroll', function () { if (!barTick) { barTick = true; requestAnimationFrame(barUpdate); } }, { passive: true });
      barUpdate();
    }
    render();
  }

  /* ---------- will my phone fit ---------- */
  function initFit(root) {
    var cfgEl = $('script[data-as-fit]', root);
    if (!cfgEl) return;
    var cfg = AS.json(cfgEl);
    var selects = $$('select[data-phone]', root);
    var head = $('[data-fit-head]', root), sub = $('[data-fit-sub]', root), box = $('[data-fit-box]', root);
    function show(id) {
      var ph = PHONES[id]; if (!ph) return;
      selects.forEach(function (s) { s.value = $('option[value="' + id + '"]', s) ? id : ''; });
      var verdict = (cfg.yes.indexOf(id) > -1) ? 'yes' : (cfg.tight.indexOf(id) > -1) ? 'tight' : (cfg.no.indexOf(id) > -1) ? 'no' : '';
      var tested = !!verdict;
      var roomH = cfg.h - ph[1], roomW = cfg.w - ph[2];
      if (!verdict) verdict = (roomH < 0 || roomW < 0) ? 'no' : (roomH < 8 || roomW < 8) ? 'tight' : 'yes';
      var dims = Math.round(ph[1]) + ' × ' + Math.round(ph[2]) + 'mm';
      head.textContent = verdict === 'yes' ? ph[0] + ' fits' : verdict === 'tight' ? ph[0] + ' fits, but it’s snug' : ph[0] + ' won’t fit';
      sub.textContent = tested
        ? (verdict === 'no' ? 'On our fit list as a no: opened out it’s too wide.' : verdict === 'tight' ? 'On our fit list, but snug. A bulky case may need to come off.' : 'On our fit list, with a slim case on.')
        : (verdict === 'no' ? 'At ' + dims + ' it’s bigger than the space inside.' : 'We haven’t tested it yet, but at ' + dims + ' it’s inside the measurements' + (verdict === 'tight' ? ', with little room for a case.' : ', with room for a slim case.'));
      box.classList.toggle('is-no', verdict === 'no');
    }
    selects.forEach(function (s) { s.addEventListener('change', function () { if (s.value) show(s.value); }); });
    show(cfg.start || 'ip15pm');
  }

  /* ---------- will my phone fit: the popup ---------- */
  function initFitDialog() {
    var dlg = $('[data-as-fitdlg]');
    if (!dlg || typeof dlg.showModal !== 'function') return; // old browsers keep the plain link to the page
    var cfg = AS.json($('[data-fitdlg-cfg]', dlg)), sel = $('[data-fitdlg-phone]', dlg), opener = null;
    function verdict(id, c) {
      var ph = PHONES[id];
      var v = c.yes.indexOf(id) > -1 ? 'yes' : c.tight.indexOf(id) > -1 ? 'tight' : c.no.indexOf(id) > -1 ? 'no' : '';
      var tested = !!v, roomH = c.h - ph[1], roomW = c.w - ph[2];
      if (!v) v = (roomH < 0 || roomW < 0) ? 'no' : (roomH < 8 || roomW < 8) ? 'tight' : 'yes';
      var head = v === 'yes' ? 'Fits' : v === 'tight' ? 'Fits, snug' : 'Won’t fit';
      var note = v === 'no' ? (tested ? 'Too wide opened out.' : 'Too big for the space inside.')
        : tested ? (v === 'tight' ? 'Tested: a bulky case may need to come off.' : 'Tested, with a slim case on.')
        : 'Inside the measurements; not tested yet.';
      return { v: v, head: head, note: note };
    }
    function draw() {
      var id = sel.value;
      $$('[data-fitdlg-row]', dlg).forEach(function (row) {
        var key = row.getAttribute('data-fitdlg-row'), out = $('[data-v]', row);
        row.classList.remove('is-yes', 'is-tight', 'is-no');
        if (!id || !PHONES[id]) { out.textContent = key === 'mini' ? 'Keys and cards only' : 'Choose a phone'; return; }
        var r = verdict(id, cfg[key]);
        if (key === 'mini' && r.v === 'no') r = { v: 'no', head: 'Won’t fit', note: 'Made for keys and cards.' };
        row.classList.add('is-' + r.v);
        out.innerHTML = '';
        var b = document.createElement('strong'); b.textContent = r.head;
        var s = document.createElement('small'); s.textContent = r.note;
        out.appendChild(b); out.appendChild(s);
      });
      try { if (id) localStorage.setItem('as-phone', id); } catch (e) {}
    }
    sel.addEventListener('change', draw);
    try { var saved = localStorage.getItem('as-phone'); if (saved && PHONES[saved]) sel.value = saved; } catch (e) {}
    draw();
    function open(e) {
      e.preventDefault();
      opener = document.activeElement;
      dlg.showModal();
      sel.focus();
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-fit-open], a[href*="/pages/waterproof-pocket-size"]');
      if (!a || a.hasAttribute('data-fitdlg-page') || e.metaKey || e.ctrlKey || e.shiftKey) return;
      open(e);
    });
    $('[data-fitdlg-close]', dlg).addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); }); // tap outside closes
    dlg.addEventListener('close', function () { if (opener && opener.focus) opener.focus(); });
  }

  /* ---------- silent pocket loops (GIF-like): load and play only in view, never for reduced motion ---------- */
  function initLoop(v) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) { v.src = v.getAttribute('data-as-loop'); v.play().catch(function () {}); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { if (!v.src) v.src = v.getAttribute('data-as-loop'); v.play().catch(function () {}); }
        else if (v.src) v.pause();
      });
    }, { rootMargin: '200px 0px' });
    io.observe(v);
  }

  /* ---------- floating pocket: features surface one by one as the section scrolls past ---------- */
  function initFloat(root) {
    var labs = $$('[data-fl-lab]', root), stage = $('.fl-stage', root);
    if (!labs.length || !stage) return;
    if (reduce) { labs.forEach(function (l) { l.classList.add('is-in'); }); return; }
    var ticking = false;
    function update() {
      ticking = false;
      var r = stage.getBoundingClientRect(), vh = window.innerHeight || 800;
      if (r.bottom < -200 || r.top > vh + 200) return;
      // 0 when the stage's top reaches the bottom of the screen, 1 when its middle reaches the screen's upper third
      var p = clamp((vh - r.top) / Math.max(1, vh - vh / 3 + r.height / 2), 0, 1);
      labs.forEach(function (l, i) { l.classList.toggle('is-in', p > 0.3 + i * 0.14); });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- in-action clips: load and play on tap ---------- */
  function initClips(root) {
    $$('[data-clip]', root).forEach(function (fig) {
      var btn = $('button', fig);
      if (!btn) return;
      btn.addEventListener('click', function () {
        var src = fig.getAttribute('data-clip');
        var existing = $('video', fig);
        if (existing) { existing.src = src; existing.controls = true; existing.muted = false; btn.remove(); fig.classList.add('is-playing'); existing.play().catch(function () {}); return; }
        var v = document.createElement('video');
        v.src = src; v.controls = true; v.playsInline = true; v.autoplay = true; v.setAttribute('playsinline', '');
        var img = $('img', fig);
        if (img) v.poster = img.currentSrc || img.src;
        fig.replaceChild(v, img || btn);
        btn.remove();
        fig.classList.add('is-playing');
        v.play().catch(function () {});
      });
    });
  }

  /* ---------- collection: sort, load more ---------- */
  function initCollection(root) {
    var toggle = $('[data-size-toggle]', root);
    if (toggle) toggle.addEventListener('click', function () {
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!panel) return;
      panel.hidden = !panel.hidden;
      toggle.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
      if (!panel.hidden) { var first = $('a', panel); if (first) first.focus(); }
    });
    $$('[data-sort]', root).forEach(function (sel) {
      sel.addEventListener('change', function () {
        var u = new URL(window.location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); window.location.href = u.toString();
      });
    });
    var more = $('[data-load-more]', root);
    if (more) more.addEventListener('click', function (e) {
      e.preventDefault();
      var url = more.getAttribute('href');
      more.classList.add('is-loading');
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = $('[data-grid]', root), next = $('[data-grid]', doc);
        if (grid && next) { Array.prototype.slice.call(next.children).forEach(function (c) { if (!c.hasAttribute('data-grid-promo')) grid.appendChild(c); }); initQuickAdd(grid); }
        var nextMore = $('[data-load-more]', doc);
        if (nextMore) { more.setAttribute('href', nextMore.getAttribute('href')); more.classList.remove('is-loading'); } else { more.remove(); }
      }).catch(function () { window.location.href = url; });
    });
  }

  /* ---------- sale countdown ---------- */
  function initCountdown(root) {
    var el = $('[data-countdown]', root);
    if (!el) return;
    var end = Date.parse(el.getAttribute('data-countdown'));
    var live = $('[data-sale-live]', root), ended = $('[data-sale-ended]', root);
    function tick() {
      var left = end - Date.now();
      if (isNaN(end) || left <= 0) { if (live) live.hidden = true; if (ended) ended.hidden = false; return; }
      if (live) live.hidden = false; if (ended) ended.hidden = true;
      var d = Math.floor(left / 864e5), h = Math.floor(left / 36e5) % 24, m = Math.floor(left / 6e4) % 60, s = Math.floor(left / 1e3) % 60;
      var vals = [d, h, m, s];
      $$('b', el).forEach(function (b, i) { b.textContent = (i > 0 && vals[i] < 10 ? '0' : '') + vals[i]; });
      setTimeout(tick, 1000);
    }
    tick();
  }

  /* ---------- tabs (size guide, landing picker) ---------- */
  function initTabs(root) {
    $$('[data-tabs]', root).forEach(function (group) {
      var btns = $$('[data-tab]', group), scope = group.closest('.as') || root;
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var id = b.getAttribute('data-tab');
          btns.forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
          $$('[data-tab-panel]', scope).forEach(function (p) { p.hidden = p.getAttribute('data-tab-panel') !== id; });
        });
      });
    });
  }

  /* ---------- quiz ---------- */
  function initQuiz(root) {
    var cfgEl = $('script[data-as-quiz]', root);
    if (!cfgEl) return;
    var cfg = AS.json(cfgEl), P = cfg.products || {};
    var s = { step: 0, who: '', phone: '', size: '' };
    var steps = $$('[data-q-step]', root);
    var NAMES = ['who', 'where', 'phone', 'size', 'result'];
    function track(name) { try { if (window.clarity) window.clarity('event', 'finder_' + name); } catch (e) {} }
    function bag() { return s.who === 'bag'; }
    function pack() { return s.who === 'pack'; }
    function gear() { return bag() || pack(); }
    // Steps in the page: 0 who, 2 phone, 3 size, 4 result. Shorts ask size, bags + pouches ask phone (optional), backpacks go straight to the kit.
    function flow() { return pack() ? [0, 4] : bag() ? [0, 2, 4] : [0, 3, 4]; }
    function next() { var f = flow(), n = f[f.indexOf(s.step) + 1]; if (n === 4) result(); go(n); }
    function go(n) {
      s.step = n;
      steps.forEach(function (el) { el.classList.toggle('is-on', parseInt(el.getAttribute('data-q-step'), 10) === n); });
      var f = flow(), total = f.length - 1, idx = f.indexOf(n);
      $('[data-q-text]', root).textContent = n === 4 ? 'Your kit' : 'Question ' + (idx + 1) + ' of ' + total;
      $('[data-q-bar]', root).style.width = (n === 4 ? 100 : Math.round(100 * idx / total)) + '%';
      $('[data-q-back]', root).hidden = n === 0;
      if (n === 2) $('[data-q-phone-help]', root).textContent = bag() ? 'Optional. We’ll check it fits the sling bag and the pouch.' : 'Optional. We’ll check it fits the pocket.';
      if (n === 3) {
        var w = s.who === 'w';
        $('[data-q-size-title]', root).textContent = w ? 'Your Usual Dress Size?' : 'Your Waist Size?';
        $('[data-q-size-help]', root).textContent = w ? 'AU sizes.' : 'In inches, like your jeans.';
        var box = $('[data-q-sizes]', root); box.innerHTML = '';
        (w ? ['6', '8', '10', '12', '14', '16', '18', '20'] : ['28', '30', '32', '34', '36', '38', '40']).forEach(function (v) {
          var b = document.createElement('button'); b.type = 'button'; b.textContent = v;
          b.addEventListener('click', function () { s.size = v; next(); });
          box.appendChild(b);
        });
      }
      if (!initial) track(NAMES[n]);
      // Move focus to the new question for screen readers, but not on page load
      var focus = !initial && $('[data-q-step="' + n + '"] h1, [data-q-step="' + n + '"] h2', root);
      if (focus) { focus.setAttribute('tabindex', '-1'); focus.focus({ preventScroll: true }); }
    }
    var initial = true;
    function pick(key, val) { s[key] = val; next(); }
    $$('[data-q-pick]', root).forEach(function (b) { b.addEventListener('click', function () { var kv = b.getAttribute('data-q-pick').split(':'); pick(kv[0], kv[1]); }); });
    $$('select[data-q-phone]', root).forEach(function (sel) {
      sel.addEventListener('change', function () {
        if (!sel.value) return; s.phone = sel.value;
        $('[data-q-fit]', root).textContent = fitText(); $('[data-q-fit]', root).hidden = false;
        $('[data-q-next]', root).textContent = 'Next';
      });
    });
    $('[data-q-next]', root).addEventListener('click', next);
    $('[data-q-back]', root).addEventListener('click', function () { var f = flow(), i = f.indexOf(s.step); go(f[Math.max(0, i - 1)]); });
    // Shorts: checks the phone against the pocket. Bags + pouches: against the sling bag and the medium pouch.
    function fitText() {
      var ph = PHONES[s.phone]; if (!ph || pack()) return '';
      if (s.phone === 'zfold' || s.phone === 'pxfold') return ph[0] + ' won’t fit opened out.';
      if (!bag()) {
        var pk = [201, 140], pt = ['ip15pm', 'ip15plus', 'ip15', 's24u', 's24p', 's24', 'px8p', 'px8'];
        if (pk[0] - ph[1] < 0 || pk[1] - ph[2] < 0) return ph[0] + ' is too big for the pocket.';
        return pt.indexOf(s.phone) > -1 ? ph[0] + ' fits the pocket, with room for a slim case.' : ph[0] + ' should fit the pocket: it’s inside the measurements, though we haven’t tested it yet.';
      }
      var tested = ['ip16pm', 'ip14', 's23', 'px7'];
      var fit = [[224, 100, 'sling bag'], [180, 110, 'pouch']].filter(function (sp) { return sp[0] - ph[1] >= 0 && sp[1] - ph[2] >= 0; }).map(function (sp) { return sp[2]; });
      if (!fit.length) return ph[0] + ' is too big for the sling bag and the pouch.';
      var where = fit.length === 2 ? 'the sling bag and the pouch' : 'the ' + fit[0];
      return tested.indexOf(s.phone) > -1 ? ph[0] + ' fits ' + where + ', with room for a slim case.' : ph[0] + ' should fit ' + where + ': it’s inside the measurements, though we haven’t tested it yet.';
    }
    var WHY = {
      w: ['Your Kit', 'Every women’s style available in your size, in stock or on pre-order. Swim with your phone and keys on you.'],
      m: ['Your Kit', 'Every men’s style available in your size, in stock or on pre-order. Swim with your phone and keys on you.'],
      bag: ['Your Kit', 'Self-closing, magnetic seals. Your phone, cards and keys stay dry on you all day.'],
      pack: ['Your Kit', 'Waterproof backpacks that seal themselves shut, for the boat, the beach or the trail.']
    };
    var W = { '6': 'XS', '8': 'S', '10': 'M', '12': 'L', '14': 'XL', '16': '2XL', '18': '3XL', '20': '4XL' };
    var M = { '28': 'XS', '30': 'S', '32': 'M', '34': 'L', '36': 'XL', '38': '2XL', '40': '3XL' };
    var RC = { XS: [28, 33], S: [30, 34], M: [33, 37], L: [36, 40], XL: [39, 44], '2XL': [41, 46] };
    // RAKE waist in inches, relaxed to stretched (RAKE size chart cm / 2.54)
    var RK = { XS: [29.9, 33.9], S: [31.5, 35.4], M: [33.1, 37], L: [34.6, 38.6], XL: [36.2, 40.2], '2XL': [37.8, 41.7] };
    var kit = {}, order = [], altSize = {};
    function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
    // Which of this product's sizes fits the shopper? null when the brand's sizes can't be matched (they pick it themselves).
    function mySize(p) {
      var sizes = p.variants.map(function (v) { return v.size; });
      if (s.who === 'w') { var l = W[s.size]; return sizes.indexOf(l) > -1 ? l : null; }
      // A waist can sit in two ranges (e.g. 34 in 32-34 and 34-36): prefer a size that's available, then the closest fit.
      var n = parseInt(s.size, 10), best = null, bestD = 99, bestOk = false, fits = [];
      sizes.forEach(function (sz) {
        var r = /^(\d+)\s*-\s*(\d+)$/.exec(sz) ? sz.split('-').map(Number) : (p.vendor === 'Randy Cow' ? RC[sz] : p.vendor === 'RAKE' ? RK[sz] : null);
        if (!r || n < r[0] || n > r[1]) return;
        var v = variantFor(p, sz), ok = !!(v && v.available), d = Math.abs(n - (r[0] + r[1]) / 2);
        if (ok) fits.push(sz);
        if ((ok && !bestOk) || (ok === bestOk && d < bestD)) { best = sz; bestD = d; bestOk = ok; }
      });
      // on a boundary (e.g. 36 in 34-36 and 36-38) the other available size is offered too
      altSize[p.h] = fits.filter(function (z) { return z !== best; })[0] || '';
      if (best) return best;
      if (p.vendor === 'AquaStash' && sizes.indexOf(M[s.size]) > -1) return M[s.size];
      return null;
    }
    // Timesact pre-order plans travel with the kit's items when it's added to the bag
    [].concat(((cfg.shorts || {}).m) || [], ((cfg.shorts || {}).w) || [], cfg.extras || [], cfg.packs || []).forEach(function (p) { (p.variants || []).forEach(function (v) { if (v.pre && v.sp) AS.sp[v.id] = v.sp; }); });
    function variantFor(p, size) { return p.variants.filter(function (v) { return v.size === size; })[0] || null; }
    function add(key, p, kind, sizeKnown, note, badge) {
      var v = kind !== 'short' ? (p.variants.filter(function (x) { return x.available; })[0] || null) : (sizeKnown ? variantFor(p, sizeKnown) : null);
      if (p.soldout) { v = null; badge = 'Sold out'; }
      if (!badge && v && v.pre) badge = 'Pre-order';
      kit[key] = { p: p, kind: kind, size: sizeKnown || '', v: v, on: false, note: note || '', badge: badge || '', guess: !!sizeKnown };
      order.push(key);
    }
    function result() {
      kit = {}; order = [];
      var w = WHY[s.who] || WHY.m;
      $('[data-r-title]', root).textContent = w[0];
      $('[data-r-why]', root).textContent = w[1];
      $('[data-r-fit]', root).textContent = fitText(); $('[data-r-fit]', root).hidden = !s.phone;
      var extras = cfg.extras || [], packs = cfg.packs || [];
      if (!gear()) {
        var picks = cfg.picks || {}, list = (cfg.shorts || {})[s.who] || [];
        var first = s.who === 'w' ? [picks.womens, picks.pass] : [picks.mens, picks.rake];
        var rows = list.map(function (p) {
          var sz = mySize(p), v = sz ? variantFor(p, sz) : null;
          var rank = first.indexOf(p.h) > -1 ? first.indexOf(p.h) : 9;
          // only styles available in their size (in stock or on pre-order)
          return { p: p, sz: sz, ok: !!(sz && v && v.available), rank: rank, matched: !!sz };
        }).filter(function (r) { return r.ok; });
        rows.sort(function (a, b) { return a.rank - b.rank || (b.matched - a.matched); });
        rows.slice(0, 12).forEach(function (r, i) { add('s' + i, r.p, 'short', r.sz, '', r.rank === 0 ? 'Our pick' : ''); });
        extras.concat(packs).forEach(function (x, i) { add('x' + i, x, 'extra', '', x.note, ''); });
        // nothing starts ticked: the shopper picks every item themselves
        $('[data-r-h1]', root).textContent = 'Swim Shorts In Your Size';
        $('[data-r-h2]', root).textContent = 'Complete Your Kit';
        var other = s.who === 'w' ? cfg.men_url : cfg.women_url;
        $('[data-r-more]', root).innerHTML = other ? '<a class="as-kitr__two" href="' + esc(other) + '"><strong>Shopping for two?</strong> Every item counts towards the kit discount. See the ' + (s.who === 'w' ? 'men’s' : 'women’s') + ' shorts →</a>' : '';
      } else {
        var mainList = pack() ? packs : extras, otherList = pack() ? extras : packs;
        mainList.forEach(function (x, i) { add('x' + i, x, 'extra', '', x.note, ''); });
        otherList.forEach(function (x, i) { add('y' + i, x, 'more', '', x.note, ''); });
        $('[data-r-h1]', root).textContent = pack() ? 'Waterproof Backpacks' : 'Bags + Pouches';
        $('[data-r-h2]', root).textContent = otherList.length ? (pack() ? 'Add Bags + Pouches' : 'Add A Waterproof Backpack') : '';
        $('[data-r-more]', root).innerHTML = '<a class="as-kitr__two" href="' + esc(cfg.women_url || '#') + '"><strong>Add swim shorts?</strong> Women’s shorts with a waterproof pocket →</a><a class="as-kitr__two" href="' + esc(cfg.men_url || '#') + '"><strong>Add swim shorts?</strong> Men’s shorts with a waterproof pocket →</a>';
      }
      draw();
    }
    function card(key) {
      var k = kit[key], p = k.p, was = p.compare > p.price ? ' <s>' + AS.money(p.compare) + '</s>' : '';
      var sizeLine = k.kind !== 'short' ? '' : (k.guess ? 'Your size: <b>' + esc(k.size) + '</b>' + (k.v && k.v.pre ? ' (pre-order)' : '') + (altSize[p.h] ? '<br><small>' + esc(altSize[p.h]) + ' also fits. Check the size chart in Details.</small>' : '') : 'Check their size chart for your size');
      return '<article class="as-kitc' + (k.on ? ' is-on' : '') + '" data-key="' + key + '">' +
        '<button type="button" class="as-kitc__img" data-open="' + key + '" aria-label="More about ' + esc(p.title) + '">' + (p.images[0] ? '<img src="' + esc(p.images[0]) + '" alt="" loading="lazy" width="350" height="440">' : '') +
        (k.badge ? '<span class="as-kitc__badge">' + esc(k.badge) + '</span>' : '') + '</button>' +
        '<div class="as-kitc__body"><strong class="as-kitc__t">' + esc(p.title) + '</strong>' +
        (k.note ? '<p class="as-kitc__note">' + esc(k.note) + '</p>' : '') +
        (sizeLine ? '<p class="as-kitc__size">' + sizeLine + '</p>' : '') +
        '<b class="as-kitc__price">' + AS.money(k.v ? k.v.price : p.price) + was + '</b>' +
        '<div class="as-kitc__acts"><button type="button" class="as-kitc__add" data-toggle="' + key + '" aria-pressed="' + k.on + '"' + (p.soldout ? ' disabled' : '') + '>' + (p.soldout ? 'Sold out' : k.on ? '✓ In your kit' : '+ Add to kit') + '</button>' +
        '<button type="button" class="as-kitc__more" data-open="' + key + '">Details</button></div></div></article>';
    }
    function draw() {
      var l1 = order.filter(function (k) { return gear() ? kit[k].kind === 'extra' : kit[k].kind === 'short'; }), l2 = order.filter(function (k) { return gear() ? kit[k].kind === 'more' : kit[k].kind === 'extra'; });
      $('[data-r-list1]', root).innerHTML = l1.map(card).join('') || '<p>Nothing in stock in that size right now. Email us at <a href="mailto:info@aquastash.com.au">info@aquastash.com.au</a> and we’ll tell you when it’s back.</p>';
      $('[data-r-list2]', root).innerHTML = l2.map(card).join('');
      totals();
    }
    function toggle(key) {
      var k = kit[key];
      if (k.p.soldout) return;
      if (!k.on && !k.v) { openDetails(key); return; } // size not matched yet: choose it in the details panel
      k.on = !k.on; if (k.on) track('kit_add_' + k.kind);
      draw();
    }
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-toggle]'); if (t) { toggle(t.getAttribute('data-toggle')); return; }
      var o = e.target.closest('[data-open]'); if (o) openDetails(o.getAttribute('data-open'));
    });
    var dlg = $('[data-r-dialog]', root), dKey = null;
    function openDetails(key) {
      var k = kit[key], p = k.p; dKey = key;
      $('[data-d-imgs]', dlg).innerHTML = p.images.map(function (u) { return '<img src="' + esc(u) + '" alt="" loading="lazy" width="350" height="440">'; }).join('');
      $('[data-d-tag]', dlg).textContent = k.badge;
      $('[data-d-title]', dlg).textContent = p.title;
      $('[data-d-price]', dlg).innerHTML = AS.money(k.v ? k.v.price : p.price) + (p.compare > p.price ? ' <s>' + AS.money(p.compare) + '</s>' : '');
      $('[data-d-note]', dlg).textContent = k.note; $('[data-d-note]', dlg).hidden = !k.note;
      $('[data-d-desc]', dlg).textContent = p.desc;
      $('[data-d-link]', dlg).href = p.url;
      var sz = $('[data-d-sizes]', dlg);
      if (k.kind === 'short') {
        sz.innerHTML = '<span>Size' + (k.guess ? ' (we picked ' + esc(k.size) + ' for you)' : '') + '</span><div class="as-kitd__sizes">' + p.variants.map(function (v) {
          return '<button type="button" data-sz="' + esc(v.size) + '"' + (v.available ? '' : ' disabled') + ' aria-pressed="' + (k.v && k.v.id === v.id) + '">' + esc(v.size) + (v.pre ? ' <small>Pre-order</small>' : '') + '</button>';
        }).join('') + '</div>' + (p.variants.some(function (v) { return v.pre; }) ? '<p class="as-kitd__pre">' + esc((p.variants.filter(function (v) { return v.pre && v.spMsg; })[0] || {}).spMsg || 'Pre-order sizes ship as soon as new stock lands.') + '</p>' : '');
      } else if (k.v && k.v.pre) {
        sz.innerHTML = '<p class="as-kitd__pre">' + esc(k.v.spMsg || 'Pre-order: ships as soon as new stock lands.') + '</p>';
      } else sz.innerHTML = '';
      dbtn();
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      track('details');
    }
    function dbtn() { var k = kit[dKey], b = $('[data-d-add]', dlg); b.disabled = !k.v; b.textContent = k.p.soldout ? 'Sold out' : !k.v ? 'Choose a size' : (k.on ? 'Remove from kit' : 'Add to kit'); }
    dlg.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sz]');
      if (b) { var k = kit[dKey]; k.size = b.getAttribute('data-sz'); k.v = variantFor(k.p, k.size); $$('[data-sz]', dlg).forEach(function (x) { x.setAttribute('aria-pressed', x === b); }); dbtn(); draw(); return; }
      if (e.target.closest('[data-d-add]')) { var kk = kit[dKey]; if (!kk.v) return; kk.on = !kk.on; if (kk.on) track('kit_add_' + kk.kind); draw(); if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); return; }
      if (e.target === dlg && dlg.close) dlg.close(); // tap outside the panel
    });
    function totals() {
      var on = order.map(function (k) { return kit[k]; }).filter(function (k) { return k.on && k.v; });
      var n = on.length, full = on.reduce(function (t, k) { return t + k.v.price; }, 0);
      var tiers = cfg.tiers || [0, 0, 5, 10, 20], pct = tiers[Math.min(n, tiers.length - 1)] || 0;
      var price = Math.round(full * (1 - pct / 100));
      var cur = Math.min(n, 4);
      $$('[data-tier]', root).forEach(function (li) { var t = +li.getAttribute('data-tier'); li.classList.toggle('is-on', t === cur); li.classList.toggle('is-done', t < cur); });
      var nextT = n < 2 ? 2 : n < 3 ? 3 : n < 4 ? 4 : 0, need = nextT - n;
      $('[data-r-nudge]', root).innerHTML = !n ? 'Add items to start your kit. <b>The more you add, the more you save.</b>' :
        nextT ? 'Add <b>' + need + ' more</b> to save <b>' + tiers[nextT] + '%</b> on your whole kit' + (pct ? ' (you’re saving ' + pct + '% now)' : '') + '.' :
        '<b>You’ve unlocked 20% off</b> your whole kit.';
      $('[data-r-count]', root).textContent = n ? n + (n === 1 ? ' item' : ' items') + ' in your kit' : 'Your kit is empty';
      $('[data-r-total]', root).textContent = AS.money(price);
      var was = $('[data-r-was]', root); was.hidden = !pct; was.textContent = pct ? AS.money(full) : '';
      var save = $('[data-r-save]', root); save.hidden = !pct; save.textContent = pct ? 'Kit discount: ' + pct + '% off (' + AS.money(full - price) + ')' : '';
      var ship = $('[data-r-ship]', root);
      ship.hidden = !(cfg.ship > 0 && n);
      if (!ship.hidden) ship.textContent = price >= cfg.ship ? 'Ships free.' : AS.money(cfg.ship - price) + ' away from free shipping.';
      var btn = $('[data-r-addall]', root);
      btn.disabled = !n; btn.textContent = n > 1 ? 'Add ' + n + ' items to bag' : n ? 'Add to bag' : 'Add your kit to bag';
    }
    $('[data-r-addall]', root).addEventListener('click', function () {
      var btn = this, items = order.map(function (k) { return kit[k]; }).filter(function (k) { return k.on && k.v && k.v.available; }).map(function (k) { return { id: k.v.id, quantity: 1 }; });
      if (!items.length) return;
      track('add');
      btn.classList.add('is-loading');
      AS.addToCart(items).catch(function () { alert('Sorry, something went wrong adding your kit. Please try again.'); }).then(function () { btn.classList.remove('is-loading'); });
    });
    go(0);
    initial = false;
    track('start');
    // Menu shortcuts (?who=w, m or bag) skip the first question
    var pre = (new URLSearchParams(window.location.search)).get('who');
    if (pre === 'w' || pre === 'm' || pre === 'bag' || pre === 'pack') pick('who', pre);
  }

  /* ---------- click-to-play YouTube: swap the thumbnail for the player on tap ---------- */
  function initYouTube(btn) {
    if (btn.dataset.asReady) return; btn.dataset.asReady = '1';
    btn.addEventListener('click', function () {
      if (btn.querySelector('iframe')) return;
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(btn.dataset.asYt) + '?autoplay=1&playsinline=1&rel=0';
      f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true; f.title = 'Video';
      btn.appendChild(f);
    });
  }

  /* ---------- video slots: load and play only when tapped ---------- */
  function initVideo(btn) {
    if (btn._as) return; btn._as = true;
    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-playing')) return;
      var v = document.createElement('video');
      v.src = btn.getAttribute('data-as-video'); v.controls = true; v.playsInline = true; v.setAttribute('playsinline', '');
      var img = $('img', btn);
      if (img) v.poster = img.currentSrc || img.src;
      // swap the button for a plain box so the video's own controls work
      var box = document.createElement('div');
      box.className = btn.className + ' is-playing';
      box.appendChild(v);
      btn.parentNode.replaceChild(box, btn);
      v.focus();
      v.play().catch(function () {});
    });
  }

  /* ---------- phone sticky bar (home, landers): shows after the first screen, but steps aside while a button
     on the page (or the picker, or the footer) is on screen so there are never two of the same button ---------- */
  function initStickyCta(bar) {
    if (bar._as) return; bar._as = true;
    var tick = false, inView = new Set();
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) inView.add(e.target); else inView.delete(e.target); });
        update();
      });
      $$('main .as-btn, #pick, [data-as-picker], .as-footer').forEach(function (el) { if (!bar.contains(el)) io.observe(el); });
    }
    function update() {
      tick = false;
      var on = window.scrollY > window.innerHeight * 0.8 && inView.size === 0;
      bar.classList.toggle('is-on', on);
      document.documentElement.classList.toggle('as-bar-on', on && window.innerWidth < 990);
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- lander product picker: live prices, real stock, sold-out sizes crossed out ---------- */
  function initPicker(root) {
    if (root._as) return; root._as = true;
    var cfgEl = $('script[data-as-picker-cfg]', root);
    var cfg = cfgEl ? AS.json(cfgEl) : {};
    var cartTotal = cfg.cartTotal || 0;
    function ship() {
      var el = $('[data-ship-line]', root);
      if (!el || !cfg.threshold) return;
      var left = cfg.threshold - cartTotal, bar = $('[data-ship-bar]', root);
      var text;
      if (left <= 0) text = 'Your order ships free';
      else if (cfg.suggest && cfg.suggest.price >= left && cfg.suggest.price < cfg.threshold) text = 'Add ' + cfg.suggest.name + ' and your order ships free';
      else text = AS.money(left) + ' away from free shipping';
      $('[data-ship-text]', el).textContent = text;
      if (bar) bar.style.width = Math.max(4, Math.min(100, Math.round(cartTotal / cfg.threshold * 100))) + '%';
    }
    $$('[data-pick]', root).forEach(function (card) {
      var add = $('[data-pick-add]', card), sizes = $$('[data-pick-size]', card), chosen = null;
      var base = add.getAttribute('data-label');
      function draw() {
        sizes.forEach(function (b) { b.setAttribute('aria-pressed', b === chosen ? 'true' : 'false'); });
        var need = sizes.length > 0 && !chosen;
        add.classList.toggle('is-need', need);
        add.textContent = need ? 'Choose a size' : base;
        var low = $('[data-pick-low]', card);
        if (low && chosen) {
          var n = parseInt(chosen.getAttribute('data-left'), 10);
          low.hidden = !(n > 0 && n <= 5);
          low.textContent = 'Only ' + n + ' left in ' + chosen.textContent;
        }
      }
      sizes.forEach(function (b) { b.addEventListener('click', function () { if (b.disabled) return; chosen = b; draw(); }); });
      add.addEventListener('click', function () {
        var id = chosen ? chosen.getAttribute('data-pick-size') : add.getAttribute('data-variant');
        if (!id) { if (sizes[0]) { var first = sizes.filter(function (x) { return !x.disabled; })[0]; if (first) first.focus(); } return; }
        add.classList.add('is-loading');
        AS.addToCart([{ id: parseInt(id, 10), quantity: 1 }])
          .then(function (json) {
            var price = parseInt((chosen || add).getAttribute('data-price'), 10) || 0;
            cartTotal += price; ship();
            add.classList.add('is-added'); add.textContent = 'Added to bag';
            setTimeout(function () { add.classList.remove('is-added'); draw(); }, 2500);
            return json;
          })
          .catch(function (err) { add.textContent = err.message; })
          .then(function () { add.classList.remove('is-loading'); });
      });
      draw();
    });
    ship();
  }

  /* ---------- full-screen product photos ----------
     Tap or click a gallery photo to open every photo full screen, starting at that one. Swipe or use the arrow keys
     to move between them, tap a photo to zoom in on that spot, and close with the button, Escape or Back. */
  function initZoom(root) {
    var slides = $$('[data-zoom-src]', root);
    if (!slides.length || root._zoom) return;
    root._zoom = true;
    var dlg = document.createElement('dialog');
    dlg.className = 'as-zoom';
    dlg.setAttribute('aria-label', 'Product photos');
    dlg.innerHTML = '<div class="as-zoom__track" data-zoom-track></div>' +
      '<button type="button" class="as-zoom__close" data-zoom-close aria-label="Close photos">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<button type="button" class="as-zoom__nav as-zoom__nav--prev" data-zoom-step="-1" aria-label="Previous photo"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg></button>' +
      '<button type="button" class="as-zoom__nav as-zoom__nav--next" data-zoom-step="1" aria-label="Next photo"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg></button>' +
      '<span class="as-zoom__count" data-zoom-count aria-live="polite"></span>';
    document.body.appendChild(dlg);
    var track = $('[data-zoom-track]', dlg), count = $('[data-zoom-count]', dlg);
    slides.forEach(function (s) {
      var fig = document.createElement('figure');
      fig.className = 'as-zoom__slide';
      var img = document.createElement('img');
      img.alt = s.getAttribute('data-zoom-alt') || '';
      img.setAttribute('data-src', s.getAttribute('data-zoom-src'));
      img.decoding = 'async';
      fig.appendChild(img);
      track.appendChild(fig);
    });
    var figs = track.children, index = 0, pushed = false;
    function load(i) { var im = figs[i] && figs[i].firstChild; if (im && !im.src) im.src = im.getAttribute('data-src'); }
    function current() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function show(i, smooth) {
      index = Math.max(0, Math.min(figs.length - 1, i));
      load(index); load(index + 1); load(index - 1);
      track.scrollTo({ left: index * track.clientWidth, behavior: smooth && !reduce ? 'smooth' : 'auto' });
      count.textContent = figs.length > 1 ? (index + 1) + ' / ' + figs.length : '';
    }
    function unzoom() { $$('.is-zoomed', track).forEach(function (f) { f.classList.remove('is-zoomed'); f.firstChild.style.transformOrigin = ''; }); }
    function open(i) {
      unzoom();
      dlg.showModal();
      document.documentElement.classList.add('as-zoom-open');
      // let the phone's Back gesture close the viewer instead of leaving the page
      try { history.pushState({ asZoom: true }, ''); pushed = true; } catch (e) { pushed = false; }
      requestAnimationFrame(function () { show(i, false); });
    }
    function close() { if (dlg.open) dlg.close(); }
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('as-zoom-open');
      if (pushed) { pushed = false; try { if (history.state && history.state.asZoom) history.back(); } catch (e) {} }
    });
    window.addEventListener('popstate', function () { if (dlg.open) { pushed = false; dlg.close(); } });
    slides.forEach(function (s, i) {
      s.classList.add('is-zoomable');
      s.setAttribute('role', 'button');
      s.setAttribute('tabindex', '0');
      s.setAttribute('aria-label', 'View photo ' + (i + 1) + ' full screen');
      s.addEventListener('click', function () { open(i); });
      s.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(i); } });
    });
    $('[data-zoom-close]', dlg).addEventListener('click', close);
    $$('[data-zoom-step]', dlg).forEach(function (b) { b.addEventListener('click', function () { unzoom(); show(current() + parseInt(b.getAttribute('data-zoom-step'), 10), true); }); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); unzoom(); show(current() + 1, true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); unzoom(); show(current() - 1, true); }
    });
    var tick = false;
    track.addEventListener('scroll', function () {
      if (tick) return; tick = true;
      requestAnimationFrame(function () {
        tick = false;
        var i = current();
        if (i !== index) { unzoom(); index = i; load(i); load(i + 1); load(i - 1); count.textContent = figs.length > 1 ? (i + 1) + ' / ' + figs.length : ''; }
      });
    }, { passive: true });
    // tap a photo to zoom in on that spot; tap again to zoom out
    track.addEventListener('click', function (e) {
      var fig = e.target.closest('.as-zoom__slide');
      if (!fig) return;
      var img = fig.firstChild;
      if (fig.classList.contains('is-zoomed')) { fig.classList.remove('is-zoomed'); return; }
      var r = img.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      fig.classList.add('is-zoomed');
    });
    window.addEventListener('resize', function () { if (dlg.open) show(index, false); });
  }

  /* ---------- boot ---------- */
  function boot(scope) {
    scope = scope || document;
    initQuickAdd(scope);
    $$('[data-as-product-root]', scope).forEach(initProduct);
    $$('[data-as-product-root]', scope).forEach(initZoom);
    $$('[data-as-fit-root]', scope).forEach(initFit);
    $$('[data-as-float]', scope).forEach(initFloat);
    $$('[data-as-clips]', scope).forEach(initClips);
    $$('[data-as-collection]', scope).forEach(initCollection);
    $$('[data-as-sale]', scope).forEach(initCountdown);
    $$('[data-as-tabs-root]', scope).forEach(initTabs);
    $$('[data-as-quiz]', scope).forEach(initQuiz);
    $$('[data-as-yt]', scope).forEach(initYouTube);
    $$('[data-as-video]', scope).forEach(initVideo);
    $$('[data-as-sticky-cta]', scope).forEach(initStickyCta);
    $$('[data-as-picker]', scope).forEach(initPicker);
    $$('[data-as-loop]', scope).forEach(initLoop);
  }
  AS.boot = boot;
  function start() { initHeader(); initFitDialog(); boot(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  // theme editor: re-run when a section reloads
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); if (e.target.querySelector('[data-as-header]')) initHeader(); });
})();
